export default __webpack_public_path__ + "static/media/404DOGS.daf616a4.png";